import { render } from "./Navbar.vue?vue&type=template&id=611ab24a&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=611ab24a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-611ab24a"

export default script